module.exports = __webpack_public_path__ + "74cfa1ae9792365b1315884c457fc8db.webp";